import { Grid } from "@mui/material";
import { CommonEntryPointBox } from "../commonEntryPoints";
import WebchatEntryPointCustomizationContainer from "./WebchatEntryPointCustomizationContainer";
import WebchatEntryPointSetupInformationContainer from "./WebchatEntryPointSetupInformationContainer";
import { useTranslation } from "react-i18next";
import { useStyles } from "src/theme/styles";
import { WebchatEntryPoint } from "src/types/textEntryPoints";
import WebchatEntryPointCallingContainer from "./WebchatEntryPointCallingContainer";

type WebchatAdditionalSettingsProps = {
	handleChange: (e: React.ChangeEvent<any>) => void;
	entryPoint: WebchatEntryPoint;
	values: any;
	touched: any;
	errors: any;
	handleBlur: (event: React.FocusEvent) => void;
	dirty: boolean;
	isSubmitting: boolean;
};

const WebchatAdditionalSettings = ({
	handleChange,
	entryPoint,
	values,
	touched,
	errors,
	handleBlur,
	dirty,
	isSubmitting,
}: WebchatAdditionalSettingsProps) => {
	const { t } = useTranslation();
	const classes = useStyles();

	return (
		<>
			<Grid item xs={12}>
				<CommonEntryPointBox
					label={t("TextEntryPoint.ChatCustomization")}
					id="webchat-entry-point-customization-box"
					InputProps={{
						inputComponent: WebchatEntryPointCustomizationContainer,
						inputProps: {
							entryPointMappingsContainerProps: {
								processingStartDate: values.processingStartDate,
								handleChange: handleChange,
								touched: touched,
								errors: errors,
								darkModePrimaryColor:
									values.darkModePrimaryColor,
								darkModeSecondaryColor:
									values.darkModeSecondaryColor,
								lightModePrimaryColor:
									values.lightModePrimaryColor,
								lightModeSecondaryColor:
									values.lightModeSecondaryColor,
								logo: values.logo,
								welcomeMessage: values.welcomeMessage,
								topicName: values.topicName,
								agentDisplayName: values.agentDisplayName,
								requireEmail: values.requireEmail,
								requestEmail: values.requestEmail,
								requireName: values.requireName,
								requestName: values.requestName,
								customFields: values.customFields,
								showAgentName: values.showAgentName,
							},
						},
						readOnly: true,
					}}
					InputLabelProps={{
						shrink: true,
					}}
					className={classes.entryPointBox}
				/>
			</Grid>
			<Grid item xs={12}>
				<CommonEntryPointBox
					label={t("TextEntryPoint.Calling")}
					id="webchat-entry-point-calling-box"
					InputProps={{
						inputComponent: WebchatEntryPointCallingContainer,
						inputProps: {
							entryPointMappingsContainerProps: {
								handleChange: handleChange,
								touched: touched,
								errors: errors,
								callingApplicationInstanceId:
									values.callingApplicationInstanceId,
								callingEnabled: values.callingEnabled,
								agentCallingEnabled: values.agentCallingEnabled,
							},
						},
						readOnly: true,
					}}
					InputLabelProps={{
						shrink: true,
					}}
					className={classes.entryPointBox}
				/>
			</Grid>
			<Grid item xs={12}>
				<CommonEntryPointBox
					label={t("TextEntryPoint.SetupInformation")}
					id="webcaht-entry-point-setup-information-box"
					InputProps={{
						inputComponent:
							WebchatEntryPointSetupInformationContainer,
						inputProps: {
							entryPointMappingsContainerProps: {
								script: entryPoint.script,
								component: entryPoint.component,
								webhookUrl: entryPoint.webhookUrl,
								previewUrl: entryPoint.previewUrl,
								dirty: dirty,
								isSubmitting: isSubmitting,
							},
						},
						readOnly: true,
					}}
					InputLabelProps={{
						shrink: true,
					}}
					className={classes.entryPointBox}
				/>
			</Grid>
		</>
	);
};

export default WebchatAdditionalSettings;
